import React from 'react';

type CardProps = {
  children: React.ReactNode;
  className?: string;
};

const Card = ({ children, className = '' }: CardProps) => {
  return (
    <div
      className={`rounded-lg border bg-[#fff] border-[#E3E4F1] bg-white  py-6 px-8 ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
